export default __webpack_public_path__ + "locales/si/Errors.json?hash=2e03cff01dae093eafec6c5c804c41a1";